"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @function convertToUpperSnakeCase
 * @param {string} str string to convert
 * @description Converts a string to upper snake case (FOO_BAR), replaces hyphens and spaces
 * @returns {string}
 */
var convertToUpperSnakeCase = function (str) { return str.toLocaleUpperCase().replace(/-| /g, "_"); };
exports.default = convertToUpperSnakeCase;
